// extracted by mini-css-extract-plugin
module.exports = {"sidebarNav":"sidebar_sidebarNav__3WwZM","brand":"sidebar_brand__3TH0f","StickyNav":"sidebar_StickyNav___uMrs","closeIcon":"sidebar_closeIcon__YDA9h"};